import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersPaidContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={[EOrderStatus.PAID]} />;
}

export default OrdersPaidContainer;
